import store from '@/store';

// format url
function urlFormat(turl) {
    let scheme_type = store.state.user.schemes.find(x => x.id === turl.sid)?.type;
    if (scheme_type === 's') {
        return `operator/tariff/search?z=${turl.sid}&opid=${turl?.opid}&p=0`;
    } else if (scheme_type === 'p') {
        return `operator/tariff/search?z=${turl.sid}&opid=${turl?.opid}&p=${turl.pid}`;
    }
}

export {
    urlFormat,
}